
const moment = require('moment')
const timeInfo = () => {

    let serverOffset = -4
  
  
  
    let timezoneAdjust = Number(serverOffset) * 3600
    let utcTime = moment().unix()
    let localTimezoneOffsetMins = new Date().getTimezoneOffset()
    let localTimezoneOffsetSecs = localTimezoneOffsetMins * 60
    let localTime = Math.floor(utcTime);
    let dayOfWeek = moment.unix(utcTime).format('dddd')
    let timeOfDay24 = moment.unix(utcTime).format('H:mm')
    let currentHr = moment.unix(utcTime).format('H')
    let currentMin = moment.unix(utcTime).format('mm')
    let timeOfDay12 = moment.unix(utcTime).format('h:mm a')
  
    let currentDate = moment.unix(utcTime).format('MM-DD-YYYY')
    let currentDateISO = moment.unix(utcTime).format('YYYY-MM-DD')
    let startOfDay = moment.unix(utcTime).startOf('day') / 1000
    let startOfWeek = moment.unix(utcTime).startOf('week') /1000
    let startOfWeekISO = moment.unix(utcTime).startOf('week').format('YYYY-MM-DD')
  
    let startOfMonth = moment.unix(utcTime).startOf('month') / 1000
    let startOfMonthISO = moment.unix(utcTime).startOf('month').format('YYYY-MM-DD')
    let endOfDay = moment.unix(utcTime).endOf('day') / 1000
    let endOfMonth = moment.unix(utcTime).endOf('month') / 1000
    let endOfMonthISO = moment.unix(utcTime).endOf('month') / 1000
    
    let currentHrMil = moment.unix(utcTime).startOf('hour').format('HH:mm');
    let currentTimeMil = moment.unix(utcTime).format('HH:mm');
  
  
    let startOfYesterday = moment.unix(utcTime).startOf('day') / 1000 - 86400
  
    let hourAdjust = 3600
    let standardTime = {
      utcTime: utcTime,
      localTime: localTime,
      dayOfWeek: dayOfWeek,
      timeOfDay12: timeOfDay12,
      timeOfDay24: timeOfDay24,
      currentDate: currentDate,
      currentDateISO: currentDateISO,
      currentHr: currentHr,
      currentMin: currentMin,
      startOfDay: startOfDay,
      startOfWeek: startOfWeek,
      startOfWeekISO: startOfWeekISO,
      startOfMonth: Math.floor(startOfMonth),
      endOfMonth: Math.ceil(endOfMonth),
      currentHrMil: currentHrMil,
      currentTimeMil: currentTimeMil, 
      timezoneAdjust : timezoneAdjust,
      endOfDay
  
    }
    //console.log(timeData )
    return standardTime
  }
  
  module.exports = {
      timeInfo
  }